import { render, staticRenderFns } from "./ProfileAbout.vue?vue&type=template&id=a8bb868e"
import script from "./ProfileAbout.vue?vue&type=script&lang=ts"
export * from "./ProfileAbout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports